<template>
	<div>
		<p class="add-event-tip-title">Picking a Date</p>
		<p class="add-event-tip-content">We ask hosts to plan all events at least 2 weeks ahead to give people time to RSVP, and to give us time to help with marketing efforts.</p>
		<p class="add-event-tip-title">Start & End Time</p>
		<p class="add-event-tip-content">WRKPRTY coworking events must be at least 4 hours long, but the duration for other types of events can vary.</p>
		<p class="add-event-tip-title">Repeating or On-going Events</p>
		<p class="add-event-tip-content">We definitely encourage creating a recurring event as it is very helpful for guests that like to plan ahead. For example, hosting a WRKPRTY at the same time and place once a week allows people to make this a regular part of their weekly work schedule - and it makes it easier for them to tell other to join too.</p>
		<p class="add-event-tip-content">If you are interested in creating an event with a Series format, please <a @click="setModalOpen({prop:'contactForm', value: true})">contact us</a> so we can help you!</p>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	methods: {
		...mapActions(['setModalOpen'])
	}
}
</script>
